import { RECRUITEE_BACKEND } from '@core/environment-legacy/staging';

import type { ReferralsEnvironment } from './interface';

export const environment: ReferralsEnvironment = {
  environmentName: 'staging',
  angularProdMode: true,
  analytics: {
    isEnabled: true,
    key: 'DlaokckWxNBiyBoQUTZJGRRF4MeRanyf',
    requiredFeatureFlag: true,
  },
  i18n: {
    phraseAppProjectId: '33b93fa8c87183f3257609a570160087',
    editorEnabled: true,
  },
  hmr: false,
  protocol: RECRUITEE_BACKEND.protocol,
  domain: RECRUITEE_BACKEND.domain,
  authUrl: RECRUITEE_BACKEND.authUrl,
  apiUrl: RECRUITEE_BACKEND.apiUrl,
  appUrl: RECRUITEE_BACKEND.appUrl,
  webAppUrl: RECRUITEE_BACKEND.webAppUrl,
  landingPageUrl: RECRUITEE_BACKEND.appUrl,
  recaptchaSiteKey: '6LdznlAUAAAAAGaYOdwE_id-rzKrOvsc-a-LHRGl',
  websocketUrl: 'wss://api.s.recruitee.com/referral_portal_socket',
  resolveSubdomainFromHost: false,
  sentry_dsn: 'https://b8fc57fcde3e4d61b6d704b761bd9125@o18167.ingest.sentry.io/1440981',
};
